import { State, Action, StateContext, Selector } from '@ngxs/store';
import { StatesService } from 'app/services/states/states.service';
import { GetStates } from './state.actions';
import { Injectable } from '@angular/core';

export class StateStateModel {
  states: Array<object>;
}

@State<StateStateModel>({
  name: 'state',
  defaults: {
    states: [],
  }
})

@Injectable()

export class StateState {

  @Selector()
  static states(state: StateStateModel) {
    return state.states;
  }

  constructor(private statesService: StatesService) {}

  @Action(GetStates)
  getStates(
    { getState, patchState }: StateContext<StateStateModel>,
    {}: GetStates
  ) {
    if (getState().states.length) {
      return;
    }
    const states = this.statesService.getAllStates();
    patchState({ states });
  }
}
